import React from 'react';

// Hooks
import { useWorkspaceSnapshotTracking } from 'Shared/tracking/use-workspace-snapshot-tracking';

// Types
import { WorkspaceMeeting } from 'Shared/types/WorkspaceMeeting.type';

// Utils
import { formatDate } from 'Shared/utils/DateTime.utils';

// Components

import WpDayPickerDropdown from 'Wpds/components/day-picker/WpDayPickerDropdown';

// Styles
import './WorkspaceMeetingsSnapshotFilter.scss';

type Props = {
  availableWorkspaceMeetings: WorkspaceMeeting[];
  setSelectedDay: Function;
  setSelectedMonth: Function;
  selectedDay: Date;
};

const WorkspaceMeetingsSnapshotFilter = ({
  availableWorkspaceMeetings,
  setSelectedDay,
  setSelectedMonth,
  selectedDay,
}: Props) => {
  const { trackOpenedSnapshotPicker } = useWorkspaceSnapshotTracking();

  const availableDates = availableWorkspaceMeetings?.map(meeting => formatDate(meeting.startTime, 'YYYY-M-D'));

  const disabledMatcher = (day: Date) => {
    const dayString = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
    return !availableDates.includes(dayString);
  };

  const hasMeetingModifier = (day: Date) => {
    const dayString = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
    return availableDates.includes(dayString);
  };

  const baseClassName = 'WorkspaceMeetingsSnapshotFilter';

  return (
    <div className={baseClassName}>
      <WpDayPickerDropdown
        placement="bottom-end"
        disabledDays={disabledMatcher}
        selected={selectedDay}
        onMonthChange={setSelectedMonth}
        onSelect={setSelectedDay}
        toDate={new Date()}
        modifiers={{
          hasMeeting: hasMeetingModifier,
        }}
        modifiersClassNames={{
          hasMeeting: `${baseClassName}__day-has-meeting`,
        }}
        onOpen={() => trackOpenedSnapshotPicker()}
      />
    </div>
  );
};

export default WorkspaceMeetingsSnapshotFilter;
